import { useEffect } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { CANDY_APPLE } from 'HubStyleTokens/colors';
import useCrmObjectTypeTracking from 'framework-listing-lib/internal/hooks/useCrmObjectTypeTracking';
import { useViews } from 'framework-listing-lib/internal/ViewTabs/providers/ViewsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewModifiedDot = styled.div.withConfig({
  displayName: "SaveViewButton__ViewModifiedDot",
  componentId: "sc-1l1wwf8-0"
})(["background-color:", ";border-radius:50%;height:10px;width:10px;position:absolute;right:-5px;top:-5px;"], CANDY_APPLE);
export default function SaveViewButton({
  onClick,
  size
}) {
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const {
    isCurrentViewModified
  } = useViews();
  useEffect(() => {
    const handleKeyDown = event => {
      const isSaveKey = event.key === 's' && (event.ctrlKey || event.metaKey);
      if (isSaveKey) {
        event.preventDefault();
        onClick();
        trackCrmTableInteraction({
          action: 'save-view-via-shortcut'
        });
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClick, trackCrmTableInteraction]);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      position: 'relative'
    },
    children: [/*#__PURE__*/_jsxs(UIButton, {
      "data-test-id": "crm-listing-save-view-button",
      onClick: onClick,
      size: size,
      use: "tertiary-light",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "saveEditableView"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkListingLib.viewTabs.actions.saveView"
      })]
    }), isCurrentViewModified && /*#__PURE__*/_jsx(ViewModifiedDot, {
      "data-test-id": "crm-listing-views-modified-dot"
    })]
  });
}